export const firstCompanyList = [
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/yeogi_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/krafton_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/3dot3_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/linkagelab_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/payhere_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/opensg_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/lg_logo.png',
]

export const secondCompanyList = [
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/pengtai_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/knowhow_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/explatform_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/lisn_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/tmaxsoft_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/doodlin_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/moneylab_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/bizbee_logo.png',
]

export const learningSupportList = [
  {
    left: {
      title: '기초 학습 지원',
      value: '자체 학습에 의존',
      description:
        '자체 예습 및 복습만에 의존하여 백엔드에 처음 도전한다면 \n진입 장벽이 높을 수 있어요',
    },
    right: {
      title: '기초 학습 지원',
      value: '프리러닝 자료 + \n기초반 별도 운영',
      description:
        '강사님이 직접 구성한 프리러닝 자료로 예습하고, 별도 운영되는 \n기초 ‘아기사자반’에서 2개월 동안 기본기를 쌓아요',
    },
  },
  {
    left: {
      title: '프로젝트 구성',
      value: '개인 또는 가상의 \n미니 프로젝트',
      description: '실무 현장에서 바로 활용하기 어려운 범용적인 과제만을 진행해요',
    },
    right: {
      title: '프로젝트 구성',
      value: '실제 기업 \n프로젝트 수행',
      description:
        '실제 현업에서 수행된 과제를 바탕으로, 기업이 직접 제시한 \n요구사항을 구현하는 진짜 실무 프로젝트에 참여해요',
    },
  },
  {
    left: {
      title: 'AI 활용 학습',
      value: 'AI 도구 실습 없음 \n/ 제한적',
      description: '최신 개발 트렌드인 AI 도구 실습이 제공되지 않거나 제한적이에요',
    },
    right: {
      title: 'AI 활용 학습',
      value: 'AI 활용 실습',
      description:
        'IntelliJ의 AI Assistant 기능을 통해 실시간 코드 분석, \n오류 진단 및 최적화 방법을 직접 체험해요',
    },
  },
  {
    left: {
      title: '협업과 리뷰 루틴',
      value: '결과 중심 피드백 위주',
      description:
        '결과 위주의 일방향 피드백과 팀원 간 협업 기반의 리뷰 및 회고 \n문화가 구축되어 있지 않아요',
    },
    right: {
      title: '협업과 리뷰 루틴',
      value: '데일리 회고 \n+ 상호 코드 리뷰',
      description:
        '매일 수업 후 강사님과 진행하는 회고 시간에 그날 배운 \n내용을 복습하고, 상호 코드 리뷰를 통해 성장해요',
    },
  },
  {
    left: {
      title: '취업 지원',
      value: '제한된 취업 지원',
      description: '체계적인 취업 연계 시스템이 없으며, 수료 후 지원이 단절되는 \n경우가 많아요',
    },
    right: {
      title: '취업 지원',
      value: '취업 연계 + \n1:1 취업 지원',
      description: '참여 기업의 취업 연계 기회와 함께 커리어 코치의 \n1:1 취업 지원을 받아요',
    },
  },
  {
    left: {
      title: '학습 몰입 환경',
      value: '과제 위주의 \n자율 학습 중심',
      description: '협업 툴 사용이 제한적이며, 실제 기업 환경과 동일한 흐름을 \n익히기 어려워요',
    },
    right: {
      title: '학습 몰입 환경',
      value: 'Git, AWS 등 \n실무 중심 경험',
      description:
        '백엔드 실무에서 꼭 필요한 핵심 툴을 사용하며 현업과 동일한 \n환경에서 개발 경험을 쌓아요',
    },
  },
]

export const projectDescList = [
  {
    category: '1차 기초 \n프로젝트',
    title: '질의응답 기반의 게시판 구현',
    descList: [
      'Java SpringBoot를 활용하여 질의 응답 커뮤니티 사이트를 구현해요',
      'Java SpringBoot에서 JPA, Security, Thymeleaf를 활용해요',
      '배포는 Docker를 이용해서 간단하게 진행해요',
    ],
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section4_tab_img1_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section4_tab_img1_m.gif',
    contents: [
      {
        contentsId: '1-1',
        contentsIntro: '화면 설계서 및 워크 플로우 작성',
        contentsInner: [
          '게시판 메인 화면 설계 \n(게시글 목록, 검색, 페이징 등)',
          '게시글 상세 화면 설계 \n(질문 내용, 답변 목록, 답변 작성 등)',
          '회원가입/로그인 화면 설계',
          '마이페이지 화면 설계 \n(내가 작성한 게시글, 답변 등)',
          '게시글 CRUD 워크플로우 설계',
        ],
      },
      {
        contentsId: '1-2',
        contentsIntro: 'DB 설계 (JPA 기반 모델 설계)',
        contentsInner: [
          '회원 정보 Entity 설계 (ID, 이메일, 비밀번호 등)',
          '게시글 Entity 설계 \n(ID, 제목, 내용, 작성자, 작성일 등)',
          '답변 Entity 설계 \n(ID, 내용, 작성자, 작성일, 게시글 ID 등)',
          '관계 매핑 설계 (회원-게시글, 게시글-답변 등)',
          'JPA 어노테이션을 활용한 Entity 클래스 구현',
        ],
      },
      {
        contentsId: '1-3',
        contentsIntro: '회원가입, 로그인, 로그아웃 기능 구현',
        contentsInner: [
          '회원가입 기능 구현 \n(이메일 중복 체크, 비밀번호 암호화 등)',
          '로그인 기능 구현 (Spring Security 활용)',
          '로그아웃 기능 구현 (Spring Security 활용)',
          '마이페이지 기능 구현 \n(내가 작성한 게시글, 답변 조회 등)',
          '권한 관리 기능 구현 (관리자, 일반 사용자 등)',
        ],
      },
      {
        contentsId: '1-4',
        contentsIntro: '질문과 답변 기능 구현 및 AWS 배포',
        contentsInner: [
          '게시글 CRUD 기능 구현 \n(Spring MVC, JPA 활용)',
          '답변 CRUD 기능 구현 \n(Spring MVC, JPA 활용)',
          '게시글 검색/정렬/페이징 기능 구현',
          'AWS EC2를 활용한 배포 환경 구축',
          'GITHUB ACTION CI/CD 파이프라인 구축, \nDocker 기반 중단 배포 구현(무중단 X)',
        ],
      },
    ],
  },
  {
    category: '2차 응용 \n프로젝트',
    title: '유료 구독 SNS 제작 \n(취업 연계 기업 ‘하들소프트’ 프로젝트)',
    descList: [
      '유료 기술 블로그 기능(팔로우, 팔로잉, 구독, 결제, 통계 등)을 구현해요',
      'Java SpringBoot를 활용하여 백엔드를 구축해요',
      'React를 활용하여 프론트엔드를 구축해요',
      'PG 결제 모듈로 결제를 구현해요',
      'Spring 배치로 결제 금액 정산을 구현해요',
      '배포는 무중단 CI/CD로 구축해요',
      '실무에서 이커머스웹 서비스의 결제, 정산 시스템을 구축하고 경험해 볼 수 있어요',
    ],
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section4_tab_img2_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section4_tab_img2_m.gif',
    contents: [
      {
        contentsId: '2-1',
        contentsIntro: '화면 설계서 및 워크 플로우 작성',
        contentsInner: [
          '메인 피드 화면 설계 (게시글 목록, 검색, 필터링 등)',
          '게시글 작성/수정 화면 설계',
          '회원 가입/로그인/마이페이지 화면 설계',
          '결제 및 구독 관리 화면 설계',
          '알림 및 알람 기능 화면 설계',
        ],
      },
      {
        contentsId: '2-2',
        contentsIntro: 'DB 설계 (JPA 기반 모델 설계)',
        contentsInner: [
          '회원 정보 Entity 설계 (ID, 이메일, 비밀번호, 프로필 정보 등)',
          '게시글 Entity 설계 (ID, 제목, 내용, 작성자, 작성일 등)',
          '댓글 Entity 설계 (ID, 내용, 작성자, 작성일, 게시글 ID 등)',
          '구독 정보 Entity 설계 (ID, 구독자, 구독 대상, 구독 기간 등)',
          '결제 정보 Entity 설계 (ID, 결제 수단, 결제 금액, 결제 일자 등)',
        ],
      },
      {
        contentsId: '2-3',
        contentsIntro: 'SpringBoot를 통해 \nREST API 설계 및 구현',
        contentsInner: [
          '회원 관리 API (회원 가입, 로그인, 마이페이지 등)',
          '게시글 CRUD API (작성, 수정, 삭제, 조회 등)',
          '댓글 CRUD API (작성, 수정, 삭제, 조회 등)',
          '구독 관리 API (구독 신청, 취소, 조회 등)',
          '결제 API (결제 요청, 결제 내역 조회 등)',
        ],
      },
      {
        contentsId: '2-4',
        contentsIntro: '클라이언트(React/Svelte/\nThymeleaf 택1) 구현 후 AWS 무중단 배포',
        contentsInner: [
          '선택한 클라이언트 프레임워크(React/Svelte/Thymeleaf) 기반 UI 구현',
          '서버 API와의 연동 구현 (axios, fetch 등 활용)',
          'AWS EC2를 활용한 배포 환경 구축',
          'GITHUB ACTION CI/CD 파이프라인 구축, Docker 기반 무중단 배포 구현(포트 스위칭 방식의 무중단 배포)',
          '모니터링 및 로깅 시스템 구축 (CloudWatch 등)',
        ],
      },
    ],
  },
  {
    category: '3차 심화 \n프로젝트',
    title: '건설안전교육 LMS 구축 \n(취업 연계 기업 ‘카이토리’ 프로젝트)',
    descList: [
      'LMS 기능(수업관리, 수강관리, 진도관리, 교육영상 파일 관리 등)을 구현해요',
      'Java SpringBoot를 활용하여 백엔드를 구축해요',
      'React를 활용하여 프론트엔드를 구축해요',
      '교육자료(영상, 이미지)를 스토리지에 저장 후 관리해요 (데이터베이스)',
      '배포는 무중단 CI/CD로 구축해요',
      '실무에서 강의, 훈련생, 진도 관리, 교육 영상/이미지 파일을 위한 스토리지 관리, 통계를 경험할 수 있어요',
    ],
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section4_tab_img3_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section4_tab_img3_m.gif',
    contents: [
      {
        contentsId: '3-1',
        contentsIntro: '화면 설계서 및 워크플로우 작성',
        contentsInner: [
          '메인 대시보드 화면 설계',
          '강의 목록 및 상세보기 화면 설계',
          '강의 수강 화면 설계',
          '회원 가입/로그인/마이페이지 화면 설계',
          '관리자 페이지 설계',
        ],
      },
      {
        contentsId: '3-2',
        contentsIntro: 'DB 설계 (JPA 기반 모델 설계)',
        contentsInner: [
          '회원 정보 Entity 설계',
          '강의 정보 Entity 설계',
          '강의 커리큘럼 Entity 설계',
          '수강 정보 Entity 설계',
          '강의 평가 및 리뷰 Entity 설계',
        ],
      },
      {
        contentsId: '3-3',
        contentsIntro: 'SpringBoot를 통해 \nREST API 설계 및 구현',
        contentsInner: [
          '회원 관리 API',
          '강의 관리 API',
          '커리큘럼 관리 API',
          '수강 관리 API',
          '리뷰 및 평가 API',
        ],
      },
      {
        contentsId: '3-4',
        contentsIntro: '클라이언트 \n(React/Svelte/Thymeleaf 택1) 구현',
        contentsInner: [
          '메인 대시보드 구현',
          '강의 목록 및 상세보기 구현',
          '강의 수강 화면 구현',
          '회원 가입/로그인/마이페이지 구현',
          '관리자 페이지 구현',
        ],
      },
      {
        contentsId: '3-5',
        contentsIntro: 'Hibernate 및 QueryDSL을 이용한 \n검색 서비스 강화',
        contentsInner: [
          '강의 검색 기능 구현',
          '강사명 검색 기능 구현',
          '수강생 검색 기능 구현',
          '수강 기록 검색 기능 구현',
          '리뷰 검색 기능 구현',
        ],
      },
      {
        contentsId: '3-6',
        contentsIntro: 'AWS Kubernetes 기반 무중단 배포 구축',
        contentsInner: [
          'AWS EC2를 3개 이상 띄워서 Kubernetes 클러스터 구축',
          'Kubernetes 네트워크(칼리코 등) 구축',
          'NGINX 세팅(API 게이트웨이 역할)',
          'GITHUB ACTION CI/CD 파이프라인 구축, Kubernetes 기반 무중단 배포 구현(롤링 업데이트 방식의 무중단 배포)',
          '모니터링 및 로깅 시스템 구축 (CloudWatch 등)',
        ],
      },
    ],
  },
]

export const projectOutputList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img1_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img1_m.gif',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img1_thumbnail.png',
    title: 'Fluffy Time',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img2_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img2_m.gif',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img2_thumbnail.png',
    title: 'Grip',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img3_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img3_m.gif',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img3_thumbnail.png',
    title: 'Team Way',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img4_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img4_m.gif',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section5_img4_thumbnail.png',
    title: 'OMG(Oh My Guide)',
  },
]

export const curriculumDetailList = [
  {
    id: 0,
    step: '1개월차',
    titlePc: '백엔드 프로그래밍 기초',
    titleM: '백엔드 프로그래밍 기초',
    description:
      'Java의 기본 문법과 프로그래밍 구조를 익혀, Java로 간단한 프로그램을 작성할 수 있는 능력을 기르는 시간이에요.',
    contents: [
      {
        contentsId: '1',
        contentsInner: [
          'Java : Java의 기초적인 문법과 사용법 학습',
          '텍스트 기반 CRUD 구현 : Java를 활용하여 간단한 CRUD 기능 구현',
          '데이터베이스 : 데이터베이스 모델링, DML, DDL 학습',
          'GIT/GITHUB : GIT으로 협업하는 방법을 학습',
        ],
      },
    ],
    imgCss: 'curriculum_img_1',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img1_m.png',
  },
  {
    id: 1,
    step: '2개월차',
    titlePc: 'SpringBoot를 활용한 QnA \n게시판 서비스 구현',
    titleM: 'SpringBoot를 활용한 QnA 게시판 \n서비스 구현',
    description:
      'Spring Boot의 핵심 개념과 구성 요소를 이해하고, REST API 기반의 백엔드 애플리케이션 개발 경험 쌓는 시간이에요.',
    contents: [
      {
        contentsId: '2',
        contentsInner: [
          'SpringBoot : SpringBoot(IoC, Web, JPA, Security 등) 기초 학습',
          'Docker, 웹서버 : Docker로 SpringBoot를 호스팅하는 방법을 학습',
          '기초 프로젝트 : SpringBoot와 DB를 활용해 질의 응답 커뮤니티 구현',
        ],
      },
    ],
    imgCss: 'curriculum_img_2',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img2_m.png',
  },
  {
    id: 2,
    step: '3개월차',
    titlePc: 'Spring REST API 와 \nReact 연동',
    titleM: 'Spring REST API 와 React 연동',
    description:
      'Java를 기반으로 한 웹 개발 기술을 학습하여, 서버와 클라이언트가 연동되는 동적인 웹 애플리케이션을 구현하는 시간이에요.',
    contents: [
      {
        contentsId: '3',
        contentsInner: [
          'React : React의 기초적인 문법과 사용법 학습',
          'SpringBoot REST API : SpringBoot REST API로 API 서버 구축, React와 연동',
        ],
      },
    ],
    imgCss: 'curriculum_img_3',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img3_m.png',
  },
  {
    id: 3,
    step: '4개월차',
    titlePc: '이커머스와 CI/CD \n무중단배포 구축',
    titleM: '이커머스와 CI/CD 무중단배포 구축',
    description:
      '배포, 빌드, 테스트 자동화 등 인프라 관련 기술을 익히고, Java 애플리케이션을 실제 운영 환경에 적용하는 방법을 배우는 시간이에요.',
    contents: [
      {
        contentsId: '4',
        contentsInner: [
          '인프라 : AWS, CI/CD, 무중단 배포 학습',
          'PG 결제 : PG 결제 모듈 연동 방법 학습',
          'SpringBatch : SpringBatch로 신뢰성있는 배치작업구현',
          '대용량 트래픽 처리 : 응답시간 단축을 위한 데이터베이스 및 코드 최적화, 트래픽 분산',
        ],
      },
    ],
    imgCss: 'curriculum_img_4',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img4_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img4_m.png',
  },
  {
    id: 4,
    step: '5개월차',
    titlePc: '2차 응용 프로젝트',
    titleM: '2차 응용 프로젝트',
    description:
      '지금까지 학습한 내용을 바탕으로 주제를 정해 개인 또는 팀 단위의 실습 프로젝트를 수행하며 실전 감각을 익히는 시간이에요.',
    contents: [
      {
        contentsId: '5',
        contentsInner: [
          '응용 프로젝트 : 유료 구독 SNS인 DevLog 제작',
          '프로젝트 제공 기업 : 하들소프트',
        ],
      },
    ],
    imgCss: 'curriculum_img_5',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img5_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img5_pc.gif',
  },
  {
    id: 5,
    step: '6개월차',
    titlePc: '3차 심화 프로젝트',
    titleM: '3차 심화 프로젝트',
    description:
      '기업이 제시한 실제 서비스 개발 과제를 바탕으로 팀 프로젝트를 진행하며, 기획부터 배포까지 전 과정을 경험하는 시간이에요.',
    contents: [
      {
        contentsId: '6',
        contentsInner: [
          '심화 프로젝트 : 건설안전교육 LMS 구축을 위한 교육 LMS 구축',
          '프로젝트 제공 기업 : 카이토리',
        ],
      },
    ],
    imgCss: 'curriculum_img_6',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img6_pc.gif',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section6_img6_pc.gif',
  },
]

export const programDescList = [
  {
    category: '취업  \n방향성 탐색',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section9_tab_img1_ver2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section9_tab_img1_m.png',
    descList: [
      '취업 준비 로드맵 특강',
      '개별 진로 탐색, 취업 로드맵 수립, 포트폴리오 작업 방향성 탐색',
    ],
  },
  {
    category: '취업 \n역량 강화',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section9_tab_img2_ver2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section9_tab_img2_m.png',
    descList: [
      '이력서/자기소개서 작성 방법 특강 진행 (이력서 양식 및 대기업 합격 자기소개서 샘플 포함)',
      'IT 전문 취업 컨설턴트의 포트폴리오 꿀팁 대방출',
      '도메인 기반 취업 스터디 운영',
    ],
  },
  {
    category: '수료 후 \n지속 케어',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section9_tab_img3_ver2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section9_tab_img3_m.png',
    descList: [
      '우수 수료생 대상 인턴십 기회 제공 및 채용 연계',
      '교육 과정 수료 이후에도 지속적인 구직활동 현황 체크',
      '스타트업 인사팀장 출신 코치의 1:1 상담 프로그램 지원',
      '수료 후 6개월간 이력서 및 포트폴리오 첨삭 제공',
      'IT 전직무 수료생이 모인 ”세렝게티“ 네트워크를 통한 스터디, 프로젝트, IT 취업정보 공유',
    ],
  },
]

export const reviewList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img1.png',
    titleM: '항상 두번 세번 반복해서 \n설명해주셔서 이해가 쉬웠어요.',
    titlePc: '항상 두번 세번 반복해서 설명해주셔서 \n이해가 쉬웠어요.',
    descM:
      '강사님 덕분에 처음엔 이해가 되지 않던 \n내용들도 여러번 들으며 자연스럽게 \n받아들여졌던 것 같아요. 강사님과 함께하며 \n말하는 감자에서 조금은 성장했습니다!',
    descPc:
      '강사님 덕분에 처음엔 이해가 되지 않던 내용들도 여러번 \n들으며 자연스럽게 받아들여졌던 것 같아요. 강사님과 함께하며 말하는 감자에서 조금은 성장했습니다!',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img2.png',
    titleM: '노베이스인 상태로 지원했지만 \n이젠 확실한 저만의 로드맵이 \n생겼어요.',
    titlePc: '노베이스인 상태로 지원했지만 이젠 확실한 \n저만의 로드맵이 생겼어요.',
    descM:
      '아무것도 몰랐던 6개월 전에 내가 이제 앞으로 \n무엇을 해야 할지 방향을 잡아주었습니다. \n열정적인 강사님, 멘토님, 매니저님 덕분에 \n많은 게 바뀌었습니다',
    descPc:
      '아무것도 몰랐던 6개월 전에 내가 이제 앞으로 무엇을 \n해야 할지 방향을 잡아주었습니다. 열정적인 강사님, \n멘토님, 매니저님 덕분에 많은 게 바뀌었습니다',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img3.png',
    titleM: '실무 스킬을 경험할 수 있다는 \n점이 가장 큰 장점!',
    titlePc: '실무 스킬을 경험할 수 있다는 점이 \n가장 큰 장점!',
    descM:
      '실무에서 쓰이는 플로우차트에 따라 \n프로젝트를 하는 경험이 필요했는데 그것을 할 \n수 있어서 너무 좋았다',
    descPc:
      '실무에서 쓰이는 플로우차트에 따라 프로젝트를 하는 \n경험이 필요했는데 그것을 할 수 있어서 너무 좋았다',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img4.png',
    titleM: '‘자신감’을 키울 수 있다는 점',
    titlePc: '‘자신감’을 키울 수 있다는 점',
    descM:
      '백엔드 개발자로 성장하는데 필요한 역량과 \n자신감을 키울 수 있는 뜻깊은 과정이었습니다. \n모두들 수고 많으셨습니다!',
    descPc:
      '백엔드 개발자로 성장하는데 필요한 역량과 자신감을 \n키울 수 있는 뜻깊은 과정이었습니다. \n모두들 수고 많으셨습니다!',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img5.png',
    titleM: '개발은 어려운 것이 아니라 \n재미있다는 것이라는 \n생각이 들었어요',
    titlePc: '개발은 어려운 것이 아니라 재미있다는 것\n이라는 생각이 들었어요',
    descM: '개발이 참 재밌다는 걸 알게 되었습니다.',
    descPc: '개발이 참 재밌다는 걸 알게 되었습니다.',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img6.png',
    titleM: '노베이스 상태인 저에게 신세계를 \n보여주신 분이십니다.',
    titlePc: '노베이스 상태인 저에게 신세계를 \n보여주신 분이십니다.',
    descM:
      '강사님의 강의가 이제 곧 끝난다니... 씁쓸한 \n마음이 들었습니다. 친절하게 응답을 해주시고, \n안될때는 끝까지 도움 주셔서 정말 감사합니다.',
    descPc:
      '강사님의 강의가 이제 곧 끝난다니... 씁쓸한 마음이 \n들었습니다. 친절하게 응답을 해주시고, 안될때는 끝까지 \n도움 주셔서 정말 감사합니다.',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img7.png',
    titleM: '어려운 점은 커피챗을 통해 \n상담할 수 있어서 좋았어요.',
    titlePc: '어려운 점은 커피챗을 통해 상담할 수 \n있어서 좋았어요.',
    descM:
      '코드를 짜는것에 어려움이 있어서 커피챗으로 \n상담을 진행했는데 강사님 말씀 덕분에 위안이 \n되었고 더 열심히 해야겠구나 라고 느낄수 \n있었습니다!',
    descPc:
      '코드를 짜는것에 어려움이 있어서 커피챗으로 상담을 \n진행했는데 강사님 말씀 덕분에 위안이 되었고 더 열심히 \n해야겠구나 라고 느낄수 있었습니다!',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img8.png',
    titleM: '무엇 하나 부족한 점 없는 \n프로젝트 퀄리티',
    titlePc: '무엇 하나 부족한 점 없는 프로젝트 퀄리티',
    descM: '덕분에 좋은 프로젝트 경험을 쌓았습니다.',
    descPc: '덕분에 좋은 프로젝트 경험을 쌓았습니다.',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section12_img9.png',
    titleM: '혼자 공부한다는 생각이 전혀 \n들지 않아요.',
    titlePc: '혼자 공부한다는 생각이 전혀 들지 않아요.',
    descM: '친절한 강사님과 도움을 주신 멘토분들께 너무 \n감사하다.',
    descPc: '친절한 강사님과 도움을 주신 멘토분들께 너무 감사하다.',
  },
]

export const benefitSlideList = [
  {
    title: '교육비 전액 무료',
    desc: '내일배움카드로 약 1,700만원 상당의 교육을 \n무료로 들을 수 있어요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img1_m_renew.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img1_m_renew.png',
  },
  {
    title: '훈련장려금 지급',
    desc: '매월 최대 81만 원의 훈련 지원금을 받을 수 있어요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img2_m_renew.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img2_m_renew.png',
    option:
      '*단, 국민취업제도 참여 유형을 포함한 개인의 상황에 따라 다를 수 있으며 자세한 사항은 고용 24에서 확인해 주세요.',
  },
  {
    title: '교육 장비 지원',
    desc: '교육 시작 전, 교육 장비가 필요한 인원에 \n한하여 무료로 장비를 대여해 드려요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img3_m_renew.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img3_m_renew.png',
  },
  {
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행할 수 \n있는 오프라인 공간을 지원해 드려요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img4_m_renew.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img4_m_renew.png',
  },
  {
    title: '교육에 필요한 참고 도서 지원',
    desc: '교육에 참여하는 모든 수강생에게 참고 도서를 \n무상으로 지원해 드려요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img5_m_renew.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/section13_img5_m_renew.png',
  },
]

export const applyScheduleList = [
  {
    title: '합격자 발표',
    content: '서류 제출일로부터 영업일 기준 7일 이내 \n개별 연락 안내',
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. \n단, 미성년자의 경우 참여가 어렵다는 점을 안내드립니다. \n발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다. \n국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 전공자도 교육을 통해 성장할 수 있을까요?',
      answer:
        '물론입니다. \n이미 기본기를 갖춘 전공자의 경우, ‘자바로 학습하는 컴퓨터 과학’ 콘텐츠와 고난이도 알고리즘 문제를 통해 CS 기반 이론을 확장하고, 실제 기업 과제 중심의 프로젝트를 통해 실무 감각과 협업 역량까지 강화할 수 있습니다. \n6개월 동안 제공되는 수준별 맞춤형 지원과 실무 중심 커리큘럼을 통해, 기초를 넘어 취업까지도 완성도 있게 준비할 수 있습니다.',
    },
    {
      question: '[지원] 기초가 없는 상태에서도 시작할 수 있나요?',
      answer:
        '네, 충분히 시작할 수 있습니다. \n정규 수업 전 제공되는 프리러닝 자료와 2개월 간 운영되는 기초반을 통해 Java, 알고리즘, 객체지향 등 핵심 개념을 이해하기 쉽게 학습할 수 있도록 지원합니다. \n또한, 학습자의 수준에 맞춰 구성된 6개월 간의 맞춤형 커리큘럼과 개별 피드백을 통해 기초부터 실무 프로젝트, 취업 준비까지 자연스럽게 이어질 수 있도록 설계되어 있습니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. \n모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 반드시 오프라인에서만 발급 받을 수 있나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다. \n자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기 (링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 발급 방법 확인하기 (링크)',
    },
    {
      question: '[지원] 고용24 수강신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. \n안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 백엔드 개발자가 되려는 강한 의지와 계획만 있으시면 됩니다. \n다만, 합격 후 6개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 신청 → 1차 지원서(서류) 제출 → 2차 과정적합성 검사 작성 → 최종합격자 발표 →  고용24 수강신청 순으로 진행됩니다. \n국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 2차 과정적합성 검사는 무엇인가요?',
      answer:
        '부트캠프 합류에 앞서 백엔드 Java에 대한 기본 이해를 확인하고자 하는 누구나 답할 수 있는 간단한 검사입니다. \n과정의 준비에 필요한 훈련생 수준 파악 정도이므로 합격 당락에는 영향을 미치지 않습니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요. \n*발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '현직 백엔드 개발자의 특강 및 면접 관련 프로그램을 지원합니다. 또한 최신 채용 트렌드를 반영한 전문적인 이력서 특강 및 피드백을 통한 취업 지원을 받으실 수 있습니다. \n*제공되는 프로그램 항목은 내부 사정에 의해 변경될 수 있습니다.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다.\n 1. 고용24 앱 설치 후 QR코드 인증(개인 진행)\n 2. 줌 모니터링을 통한 매시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정) \n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 시 웹캠과 마이크는 꼭 필요한가요?',
      answer:
        '네, 온라인 실시간 수업의 특성상 웹캠과 마이크는 필수 준비 항목입니다. 출결 확인 및 수업 참여도, 실습 중 질의응답 등 원활한 소통을 위해 웹캠은 항상 켠 상태로 유지해주시고, 마이크도 상황에 따라 적극 활용해주셔야 합니다. \n웹캠 및 마이크 준비가 어려운 상황이라면, 교육 매니저에게 별도 문의해주시기 바랍니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해 주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 6개월 동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
  ],
  benefit: [
    {
      question: '[혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 정규 과정 시작 전, Java 및 백엔드 기초 프리러닝 학습 자료를 제공합니다',
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 수료 후 정기적으로 진행되는 행사참여 및 네트워킹 기회를 제공합니다. (KDT 수료생에 한함)',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answer:
        '네. 훈련 장려금은 월 최대 316,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다. \n국민취업제도에 참여 중인 분들의 경우, 훈련 장려금 외에 추가 훈련 수당을 받으실 수 있으며 \n1유형에 해당하시는 분들은 500,000원의 훈련수당까지 더해 월 최대 816,000원을 지급받으실 수 있고 \n2유형에 해당하시는 분들은 284,000원의 훈련수당까지 더해 월 최대 600,000원을 지급받으실 수 있습니다. \n다만, 개인의 상황에 따라 참여 가능한 유형이 다르고 지급받을 수 있는 금액이 다를 수 있기에 반드시 고용24를 통해 확인 및 신청 바랍니다.',
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
